import React from "react";

function About(){
  return (
    <section className="page-section" id="about">
      <div className="container">
        <div className="text-center">
          <h2 className="section-heading text-uppercase">About</h2>
          <h3 className="large text-muted">
          Established in 2023, Pentagon Properties is committed to providing high quality, safe, and reliable housing in Nova Scotia. All of our properties are built, serviced, managed, and maintained in house to provide the highest quality customer service to our tenants. Through our hands-on approach and deep community roots, Pentagon Properties ensures every tenant feels at home—today, tomorrow, and for years to come.

              </h3>
        
        </div>
      
      </div>
    </section>
  );
}; 

export default About; 